exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1YJE-RKcE_7UG9yJJVTntf{min-height:100vh;position:relative;max-width:1920px;min-width:375px}._1YJE-RKcE_7UG9yJJVTntf._3aOWU_C-wZp9lq4KXbp5dF,._1YJE-RKcE_7UG9yJJVTntf._2F7-L9beAH_hPlTP8kvqxI{display:flex}._13j1vIYD1qcppsjmQ-fMb-{width:240px;box-shadow:0 1px 1px 0 rgba(0,0,0,0.08),0px 1px 6px 1px rgba(0,0,0,0.08);position:relative;z-index:2}._2F7-L9beAH_hPlTP8kvqxI ._13j1vIYD1qcppsjmQ-fMb-{width:60px;box-shadow:0 1px 1px 0 rgba(0,0,0,0.08),0px 1px 6px 1px rgba(0,0,0,0.08);position:relative;z-index:2}._2Z2prPCL_-NOM79wEXBM0v ._13j1vIYD1qcppsjmQ-fMb-{width:100%}._2nXuo6KxXZQP3-DFmZD0qO{flex:1 1;min-width:0;z-index:1}\n", ""]);

// Exports
exports.locals = {
	"SideNavLayout": "_1YJE-RKcE_7UG9yJJVTntf",
	"notCollapsed": "_3aOWU_C-wZp9lq4KXbp5dF",
	"userCollapse": "_2F7-L9beAH_hPlTP8kvqxI",
	"sidebar": "_13j1vIYD1qcppsjmQ-fMb-",
	"viewportCollapse": "_2Z2prPCL_-NOM79wEXBM0v",
	"content": "_2nXuo6KxXZQP3-DFmZD0qO"
};